import { isNullOrUndefined } from "ceres/app/helper/utils";

export function makeProductArray(items) {

    const products = [];

    for (const key in items) {

        let manufacturer = "";

        if (!isNullOrUndefined(items[key].variation.data.item.manufacturer) && !isNullOrUndefined(items[key].variation.data.item.manufacturer.name)) {
            manufacturer = items[key].variation.data.item.manufacturer.name;
        }

        let categoryId = "";

        if (!isNullOrUndefined(items[key].variation.data.ids.categories.branches) && !isNullOrUndefined(isNullOrUndefined(items[key].variation.data.ids.categories.branches[0]))) {
            categoryId = items[key].variation.data.ids.categories.branches[0];
        }

        products.push({
            "name": items[key].variation.data.texts.name1,
            "id": items[key].itemId + "",
            "price": items[key].price + "",
            "brand": manufacturer,
            "category": categoryId + "",
            "variant": items[key].variation.id + "",
            "quantity": items[key].quantity
        });
    }

    return products;
}
